const getStyles = () => {
  return {
    // Section Wrapper
    section: {
      padding: '100px 0',
      background: 'linear-gradient(180deg, #f9fafb 0%, #ffffff 100%)'
    },

    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 16px',
      '@media (min-width: 640px)': {
        padding: '0 24px'
      }
    },

    // Header Section
    header: {
      textAlign: 'center',
      marginBottom: '64px',
      animation: 'fadeIn 0.8s ease-out'
    },

    iconWrapper: {
      width: '64px',
      height: '64px',
      borderRadius: '50%',
      margin: '0 auto 24px auto',
      background: 'linear-gradient(135deg, #4f46e5 0%, #38bdf8 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 8px 24px rgba(99,102,241,0.4)'
    },

    icon: {
      fontSize: '36px',
      color: '#fff'
    },

    title: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      color: '#1a202c',
      marginBottom: '12px',
      '@media (min-width: 768px)': {
        fontSize: '3rem'
      }
    },

    subtitle: {
      fontSize: '1.25rem',
      color: '#6b7280',
      maxWidth: '600px',
      margin: '0 auto'
    },

    // Card Styles
    card: {
      maxWidth: '900px',
      margin: '0 auto',
      border: '2px solid #e5e7eb',
      borderRadius: '20px',
      boxShadow: '0 10px 40px rgba(0, 0, 0, 0.05)',
      backgroundColor: '#ffffff',
      animation: 'fadeIn 0.8s ease-out'
    },

    cardContent: {
      padding: '48px 32px',
      display: 'flex',
      flexDirection: 'column',
      gap: '24px'
    },

    // Term item
    termItem: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
      borderBottom: '1px solid #e5e7eb',
      paddingBottom: '20px',
      animation: 'fadeIn 0.8s ease-out',
      '&:last-of-type': {
        borderBottom: 'none'
      }
    },

    termIndex: {
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: 'rgba(170, 148, 222, 0.1)',
      color: '#4f46e5',
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1rem',
      flexShrink: 0
    },

    termContent: {
      flex: 1
    },

    termTitle: {
      fontSize: '1.1rem',
      fontWeight: 600,
      color: '#1f2937',
      marginBottom: '6px'
    },

    termDescription: {
      color: '#6b7280',
      lineHeight: 1.7,
      fontSize: '0.95rem'
    },

    footerNote: {
      textAlign: 'center',
      color: '#6b7280',
      maxWidth: '700px',
      margin: '40px auto 0 auto',
      lineHeight: 1.6
    },

    // Animations
    '@keyframes fadeIn': {
      '0%': { opacity: 0, transform: 'translateY(20px)' },
      '100%': { opacity: 1, transform: 'translateY(0)' }
    }
  };
};

export default getStyles;
